import commApi from "@/api/apis/common.js";
// 生成32位字符串
export function getRandomStr32() {
  var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
  var str_nums = "";
  for (var i = 0; i < 32; i++) {
    var id = parseInt(Math.random() * (arr.length - 1));
    str_nums += arr[id];
  }
  return str_nums;
}

// 友盟统计
export function loadStat() {
  var script = document.createElement('script');
  script.src = 'https://v1.cnzz.com/z_stat.php?id=1280689875';
  document.body.appendChild(script);

  // var script1 = document.createElement('script');
  // script1.src = 'https://c.cnzz.com/core.php?web_id=1280689875&t=z';
  // document.body.appendChild(script1);
  // 文字形式
  // document.write(unescape("%3Cspan id='cnzz_stat_icon_1280689875'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1280689875' type='text/javascript'%3E%3C/script%3E"));
  // 图片形式1
  // document.write(unescape("%3Cspan id='cnzz_stat_icon_1280689875'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1280689875%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"));
  // 图片形式2
  // document.write(unescape("%3Cspan id='cnzz_stat_icon_1280689875'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1280689875%26show%3Dpic1' type='text/javascript'%3E%3C/script%3E"));
  // 图片形式3
  // document.write(unescape("%3Cspan id='cnzz_stat_icon_1280689875'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1280689875%26show%3Dpic2' type='text/javascript'%3E%3C/script%3E"));
}

// 深度复制
export function deepClone(obj) {
  let result = Array.isArray(obj) ? [] : {}
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object') {
        result[key] = obj[key] !== null ? deepClone(obj[key]) : obj[key]
      } else {
        result[key] = obj[key]
      }
    }
  }
  return result
}

// 验证是否是手机号
export function testMobilePhone(phoneNum) {
  // var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
  var reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  return reg.test(phoneNum);
}

// 获取URL中的全部参数
export function getUrlParamObj(url) {
  var arr = [];
  var query = {};
  if (url.indexOf('?') > -1) {
    arr = url.split('?')[1];
    if (arr.length > 0) {
      var list = arr.split("&");
      list.length > 0 && list.forEach(item => {
        let mm = item.split('='),
          key = mm[0],
          value = mm[1];
        query[key] = value
      });
    }
  }
  return query;
}

/* 获取选项标签 */
export function getSelectLabel(index) {
  var list = [
    "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z",];
  return list[index];
}

// 增加积分
export function addScore(params) {
  var p = {
    code: "", // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、zbj、dy、dz、sc)
    description: "", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、直播间、订阅、点赞、收藏)
    contentType: "", // 非必传，稿件的type
    contentId: "", // 非必传，稿件的id
    contentName: "", // 非必传，稿件的标题
    // deviceId:, // 设备id，客户端则传设备id，静态页不传
    memberId: null, // 必传，会员id
  };
  params = Object.assign(p, params);

  commApi
    .addScore(params)
    .then((res) => {
      if (res.suc == 1) {
        console.log("积分添加成功！");
      } else {
        console.log("积分添加失败！");
      }
    })
    .catch((err) => {
      console.log("积分添加失败！");
    });
}